/* index.js */

"use strict";

const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;

const ConfirmDialog = require("./confirmdialogcomponent/ConfirmDialogComponent");
const MessageDialog = require("./messagedialogcomponent/MessageDialogComponent");
const StatusMessage = require("./statusmessagecomponent/StatusMessageComponent");
const ErrorMapTranslation =
    require("../settingsscreens/commoncomponents/ErrorMapTranslation").Common;

class UiUtils extends EventEmitter {
    constructor() {
        super();
        this._rootElem = null;
        this._confirmDialog = new ConfirmDialog();
        this._statusMessage = new StatusMessage();
        this._messageDialog = new MessageDialog();

        this.isItemsMatch = this.isItemsMatch.bind(this);
    }

    get rootElement() {
        return this.getRootElement();
    }

    set rootElement(val) {
        this.setRootElement(val);
    }

    getRootElement() {
        return this._rootElem;
    }

    setRootElement(val) {
        this._rootElem = val;
        this._rootElem.appendChild(this._confirmDialog.renderer.getRootElement());
        this._rootElem.appendChild(this._messageDialog.renderer.getRootElement());
        this._rootElem.appendChild(this._statusMessage.renderer.getRootElement());
    }

    showDeleteConfirmDialog(options) {
        return this._confirmDialog.askConfirmation("delete", options);
    }

    showConfirmDialog(options) {
        return this._confirmDialog.askConfirmation("normal", options);
    }

    showMessageDialog(options) {
        return this._messageDialog.showMessage(options);
    }

    writeErrorMessage(msg) {
        this._statusMessage.writeMessage(msg, true);
    }

    writeMessage(msg) {
        this._statusMessage.writeMessage(msg, false);
    }

    clearMessage() {
        this._statusMessage.clear();
    }

    /**
     * Wrap item with div, create label, and class name
     * @param {Object} element - item to wrap and create label
     * @param {string=} labelText - optional, label text
     * @param {string=} className - optional, wrapper class name
     */
    wrapElement(element, labelText, className) {
        return UiUtils.wrapElement(element, labelText, className);
    }

    /**
     * Helper function to match the errorCode to the custom error messages
     * @param {Object} err - error object
     * @returns {string} - error message
     */
    errorCodeMapping(err) {
        return UiUtils.errorCodeMapping(err);
    }

    /**
     * Deep, non strict compare or two nested Arrays/Objects
     * @param {Array || Object} objValue
     * @param {Array || Object} srcValue
     */
    isItemsMatch(objValue, srcValue) {
        return UiUtils.isItemsMatch(objValue, srcValue);
    }

    /*************************/
    /*     Static Methods    */
    /*************************/
    /**
     * Wrap item with div, create label, and class name
     * @param {Node} element - item to wrap and create label
     * @param {?string=} labelText - optional, label text
     * @param {?string=} className - optional, wrapper class name
     */
    static wrapElement(element, labelText, className) {
        let container = document.createElement("div");
        if (labelText) {
            let label = document.createElement("label");
            label.innerText = labelText;
            container.appendChild(label);
        }
        if (className) {
            container.classList.add(className);
        }
        container.appendChild(element);
        return container;
    }

    /**
     * Helper function to match the errorCode to the custom error messages
     * @param {Object} err - error object
     * @returns {string} - error message
     */
    static errorCodeMapping(err) {
        const code = _.get(err, "errorCode") || _.get(err, "error.errorCode");
        return code && ErrorMapTranslation[code]
            ? ErrorMapTranslation[code]
            : _.get(err, "errorMsg") || _.get(err, "message") || "wrong formatted error";
    }

    /**
     * Deep, non strict compare or two nested Arrays/Objects
     * @param {Array || Object} objValue
     * @param {Array || Object} srcValue
     */
    static isItemsMatch(objValue, srcValue) {
        if (_.isObject(objValue) && !_.isString(objValue)) {
            return _.isMatchWith(objValue, srcValue, UiUtils.isItemsMatch);
        } else {
            return objValue === srcValue; // jshint ignore:line
        }
    }
}

module.exports = UiUtils;
